import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { GtsService } from './gts.service';
import { GtsController } from './gts.controller';
import { BuyerEntity } from '../entities/buyer.entity';
import { PoHeaderEntity } from '../entities/po-header.entity';
import { PoLineEntity } from '../entities/po-line.entity';
import { ScheduleEntity } from '../entities/schedule.entity';
import { StyleOperationEntity } from '../entities/style-op.entity';
import { TrackingInfoEntity } from '../entities/tracking-info.entity';
import { OperationEntity } from '../entities/operation.entity';
import { DatabaseModule } from '../db.module';
import { UnitEntity } from '../entities/unit.entity';
// import { appDataSource } from '../app.module';

@Module({
  imports: [
    // DatabaseModule,
    TypeOrmModule.forFeature([
        BuyerEntity,
        OperationEntity,
        PoHeaderEntity,
        PoLineEntity,
        ScheduleEntity,
        StyleOperationEntity,
        TrackingInfoEntity,
        UnitEntity
    ])
  ],
  controllers: [GtsController],
  providers: [GtsService],
  exports:[GtsService]
})
export class GtsModule { }
